// @react-functional

import React, { useEffect } from 'react';
import { useModal } from '../../components/modal/useModal';
import { LoginModal } from '../../login/LoginModal';
import { SHOW_LOGIN_KEY } from '../../../../shared/constants/urlConstants';

export const useShowLogin = () => {
  const { openModal: openLoginModal } = useModal((modalProps) => (
    <LoginModal {...modalProps} source="url-opening" />
  ));

  useEffect(() => {
    const showLoginModal = window.location.href.includes(SHOW_LOGIN_KEY);
    if (showLoginModal) openLoginModal();
  }, []);
};
